import { getVacationTypeById } from "./lib";

export const vacationType = (id, vacationTypes) => getVacationTypeById(id,vacationTypes).name
